import React, { useEffect, useState } from "react";

export default function SvgLogo({ url, width, height, style, fit = "height", className, label }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [url]);

  return (
    <div
      className={["svg-logo", fit === "frame" ? "svg-logo--frame" : "", className]
        .filter(Boolean)
        .join(" ")}
      style={{
        width: fit === "frame" ? width : undefined,
        maxWidth: width,
        height: height || "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {url && !hasError ? (
        <img
          className="svg-logo__image"
          src={url}
          alt={label || ""}
          onError={() => setHasError(true)}
        />
      ) : (
        <span className="svg-logo__fallback">{label}</span>
      )}
    </div>
  );
}
